export const pricingFields = [
  'Asset_Type',
  'Car_Price_VAT_Inclusive',
  'Loan_Duration',
  'Down_Payment_Percentage',
  'Down_Payment_Amount',
  'Insurance_Percentage',
  'Finance_Amount',
  'Admin_Fee',
  'APR',
  'Installment_Amount',
  'Balloon_Payment_Percentage',
  'Balloon_Payment_Amount',
  'Total_Finance_Amount',
]
